import styled from 'styled-components';

import { Text } from 'src/client/components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;

  background-color: ${(props) => props.theme.colors.gray3};
  border: 1px dashed ${(props) => props.theme.colors.gray5};
  border-radius: 8px;
`;

export const RecipientChipsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const RecipientChip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  background-color: ${(props) => props.theme.colors.darkEmphasis1};
  border: 1px solid ${(props) => props.theme.colors.gray3};
  border-radius: 20px;
  padding: 6px 12px;

  max-width: calc(100% - 16px);

  min-width: 0;
`;

export const RecipientName = styled(Text)`
  color: ${(props) => props.theme.colors.white};
`;

export const RemoveButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(props) => props.theme.colors.white};

  font-size: 10px;

  transition: all 0.2s ease;

  &:hover {
    height: 16px;
    width: 16px;
    border: none;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.darkEmphasis2};
    color: ${(props) => props.theme.colors.error};
  }
`;
